import fetch from "auth/FetchInterceptor";

const returnManagementService = {};

const getStoreHeaders = () => {
  const storeId = localStorage.getItem("store_id") || "1";
  return { "Store-ID": storeId };
};

returnManagementService.getReturns = function (params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `/returns/${queryString ? `?${queryString}` : ""}`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

returnManagementService.updateReturn = function (data = {}) {
  return fetch({
    url: `/returns/`,
    method: "PUT",
    headers: getStoreHeaders(),
    data,
  });
};

export default returnManagementService;
